<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 24 24" :class="[`${prefix}-icon`, `${prefix}-icon-email`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_190a8db484__a"><rect width="24" height="24" rx="0"/></clipPath></defs><g clip-path="url(#svg_190a8db484__a)"><path d="M1.875,7.54626C1.909068,7.54627,1.942492,7.5557099999999995,1.97168,7.573589999999999L10.49292,12.79046C11.44838,13.3754,12.6439,13.37294,13.5971,12.78409L22.0277,7.57557C22.0856,7.5398,22.1579,7.53857,22.2169,7.57236C22.276,7.60614,22.3125,7.66969,22.3125,7.73861L22.3125,17.60435C22.3125,19.28985,20.9693,20.65625,19.3125,20.65625L4.6875,20.65625C3.03066,20.65625,1.6875,19.28985,1.6875,17.60435L1.6875,7.73701C1.6875,7.63166,1.7714466,7.54626,1.875,7.54626ZM19.4971,3.6562739826C20.624,3.6562739826,21.6172,4.33396,22.0666,5.33734C22.0751,5.35632,22.0841,5.37792,22.0936,5.40212C22.1934,5.65693,22.1014,5.94796,21.8744,6.09588L21.8471,6.11364L21.006,6.6683L12.7243,11.56062C12.288,11.81838,11.7493,11.81857,11.31281,11.5611L3.0135,6.66596L2.129625,6.09602C1.905094,5.95122,1.810851,5.6663,1.903664,5.4129000000000005C1.916179,5.37873,1.926586,5.35238,1.934906,5.33388C2.379773,4.344046,3.35421,3.672034,4.4636499999999995,3.656536161L4.50286,3.65625L19.4971,3.6562739826Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconEmail',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
